import React from 'react';
import styled from 'styled-components';
import { CardStyles } from './FileInfoCard';
import TMMButton from '../TMMButton';
import { color } from '@nuvolo/nuux-theme/utils';

interface AddFileButtonProps {
  onClick?: () => void;
}

const StyledButton = styled(TMMButton)`
  &.dx-button.dx-widget {
    ${CardStyles}
    height: 62px;
    flex-shrink: 0;
    padding: 0;
    width: 40px !important;

    @media (max-width: 768px) {
      width: 100% !important;
    }

    .dx-button-content i {
       color: ${color('custom', 'lightContrastText')};
    }

    &:hover,
    &.dx-state-hover {
      .dx-button-content i {
        color: ${color('custom', 'contrastText')};
      }
    }
  }
`;

const AddFileButton: React.FC<AddFileButtonProps> = ({ onClick }) => {
  return (
    <StyledButton
      type="normal"
      aria-label="Add attachment"
      onClick={onClick}
      width="40px"
      icon="plus"
    />
  );
};

export default React.memo(AddFileButton);
